import axios from "axios";

export const fetchGetAllTasksSubmit = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.post(`${baseTaskUrl}/TaskSubmission/get-list-task-submission`, data);
};
